// extracted by mini-css-extract-plugin
export var fullHeightState = "_2a-7";
export var headerCell = "_2a-1";
export var loadingStateCell = "_2a-4";
export var rowWrapper = "_2a-3";
export var standaloneTable = "_2a-8";
export var standaloneTableWithBodyFill = "_2a-9";
export var stateCell = "_2a-5";
export var table = "_2a-0";
export var tableBodyFiller = "_2a-6";
export var white = "_2a-2";